// extracted by mini-css-extract-plugin
export default {"excluded":"specialty-spaces-breakdown-table_excluded__5Vhck"};